import { render, staticRenderFns } from "./hpscorhea.vue?vue&type=template&id=5b708847"
import script from "./hpscorhea.vue?vue&type=script&lang=js"
export * from "./hpscorhea.vue?vue&type=script&lang=js"
import style0 from "./hpscorhea.vue?vue&type=style&index=0&id=5b708847&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports